import { CodeMapCategory, CodeMapTokenWithLocate } from 'adminConsole/page'
import { useCodeMapValueToName } from 'share/util/common'

type Props = {
  value?: string | number | boolean
  category: CodeMapCategory | CodeMapCategory[]
  locateAt: CodeMapTokenWithLocate
}
export const CodeMapDisplay = ({ value, category, locateAt }: Props) => {
  const { getValueToName } = useCodeMapValueToName({ locateAt })
  const valToString = value ? (typeof value === 'boolean' || typeof value === 'number' ? String(value) : value) : ''
  const name = getValueToName(category, valToString)

  const isValExist = value !== undefined

  if (!isValExist) return <span>無資料</span>

  return <span style={{ wordBreak: 'keep-all' }}>{name || '-'}</span>
}
